import * as THREE from "three";

let Colors = {
  yellow: 0xffff00,
  orange: 0xffa500,
  red: 0xff0000,
  white: 0xffffff,
};

export default class Sun {
  constructor() {
    this.mesh = new THREE.Object3D();

    // Geometry
    let geoSphere = new THREE.SphereGeometry(10, 32, 32);

    // Materials
    let matSun = new THREE.MeshBasicMaterial({ // Use BasicMaterial for self-illumination
      color: Colors.yellow,
    });

    // Meshes
    let sun = new THREE.Mesh(geoSphere, matSun);
    sun.castShadow = false; // Sun doesn't cast shadows
    sun.receiveShadow = false; // Sun doesn't receive shadows

    // Add light source to the sun
    let sunLight = new THREE.PointLight(Colors.white, 1, 0); // White light, full intensity, no distance limit
    sun.add(sunLight);

    // Add to Object3D
    this.mesh.add(sun);
  }
}
